var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, IconButton, Text, Tooltip } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { analytics } from 'app/utils/segment';
export class SidebarToggleTrigger extends PureComponent {
    toggleSidebar() {
        if (!this.props.isMenuOpen) {
            analytics.conversationSidebarOpened();
        }
        else {
            analytics.conversationSidebarClosed();
        }
        this.props.toggleSidebar();
    }
    render() {
        const { isMenuOpen } = this.props;
        return (_jsxs(FlexBox, Object.assign({ alignItems: "center", justifyContent: "space-between", padding: "300" }, { children: [isMenuOpen && (_jsx(Text.Paragraph, Object.assign({ variant: "3", subdued: true }, { children: "Customer Info" }))), _jsx(Tooltip, Object.assign({ content: isMenuOpen ? 'Close' : 'Show', dark: true }, { children: _jsx(IconButton, { variant: "tertiary", onClick: this.toggleSidebar, icon: isMenuOpen ? 'angle-double-right' : 'angle-double-left' }) }))] })));
    }
}
__decorate([
    boundMethod
], SidebarToggleTrigger.prototype, "toggleSidebar", null);
